import React from 'react';
import styled from 'styled-components';

export default styled(props => <span {...props}>$</span>)`
  position: absolute;
  top: calc(0.375rem / 2);
  left: 0;
  width: 2rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 2.5rem;
`;
